export default "__VITE_ASSET__CYVh9gq___"